<template>
  <TemplateContentSingle>
    <TemplateSectionWithHeader>
      <template #header>
        <div class="header-with-action">
          <heading tag="h1">Mon planning de révision </heading>
          <ButtonCircleIcon
            class="button-add"
            icon-name="plus"
            theme="secondary-light"
            size="small"
            :to="pathAdd"
            @click.capture="handleClickAdd"
          />
        </div>
      </template>
      <AssessmentList v-if="items.length" :items="items" />
      <div v-else class="empty">
        <AssessmentListEmpty />
      </div>
    </TemplateSectionWithHeader>
  </TemplateContentSingle>
</template>

<script lang="ts" setup>
import DialogNotASubscriber from '~/components/categories/assessment/dialog/DialogNotASubscriber.vue';

const profile = useProfileStore();

const dialog = useDialogStore();

const pathAdd = computed(() => {
  return `/${Sections.ChildForYou}/eval/ajouter`;
});

const handleClickAdd = (e) => {
  if (profile.canCreateNewAssessment) return;
  dialog.open(DialogNotASubscriber, {
    position: 'center',
    level: DialogLevel.Info,
    onClose: () => {
      navigateTo(`/${Sections.ChildForYou}`);
    },
  });
  return e.preventDefault();
};

const assessmentsStore = useAssessmentsStore();

const { load, items } = useAssessmentsList();

await load();

watch(
  () => assessmentsStore.assessments,
  async () => {
    await load();
  }
);
</script>

<style lang="scss" scoped>
.button-add {
  margin-left: var(--gap_n);
}
.header-with-action {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: var(--gap_s);
  align-items: center;
}
.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50vh;
  height: 50dvh;
  min-height: 26rem;
}
</style>
